import http from "./http"
const report = {
  //专家审稿统计
  getExportReport(timeRange, type) {
    let data = { timeRange, type }
    return http.post("article/Article/getAuditCount", data)
  },
}
export default report
